import { useRef, useEffect, useState } from "react";
import GetIcon from "../../../../../utils/Icon";
import Button from "../../../../../Core/Button/Button";
import Pagination from "../../../../../Components/Pagination";
import { handleDownloadCSV } from "../../../../../utils/CsvDownload";
import { usePostItemScanApiMutation } from "../../../../../store/api/salesinvoiceAuricApi";
import EditItemModal from "./EditItemModal";
import ConfigureColumns from "../Components/ConfigureColumns";
import { formatIndianPriceWithComa } from "../../../../../utils/formatIndianPrice2";

const ItemTable = ({ po_status, setRows, rows, error, ListAPI,formData }) => {
  const createNewRow = () => ({
    item: '',
    quantity: 0,
    item_code: "",
    item_name: "",
    custom_pure_gold: "",
    custom_stone_weight: "",
    custom_diamond_weight: "",
  });

  const initialColumns = [
    { key: "action", name: "Action", width: "6%", selected: true },
    { key: "slno", name: "Sl.No", width: "6%", selected: true },
    { key: "design_code", name: "Design Code", width: "12%", selected: true },
    { key: "item_name", name: "Item Name", width: "20%", selected: true },
    { key: "diamond_weight", name: "Diamond Weight", width: "10%", selected: true },
    { key: "stone_weight", name: "Stone Weight", width: "10%", selected: true },
    { key: "pure_gold", name: "Pure Gold", width: "10%", selected: true },
    { key: "rate", name: "Rate", width: "10%", selected: true },
    { key: "amount", name: "Amount", width: "10%", selected: true },
    { key: "setting", name: "Setting", width: "6%", selected: true },
  ];

  const [columns, setColumns] = useState(initialColumns);
  const [showColumnConfig, setShowColumnConfig] = useState(false);
  const visibleColumns = columns.filter(col => col.selected);
  const [selectedRow, setselectedRow] = useState(null);

  // NEW STATE VARIABLES FOR ITEM SEARCH DROPDOWN
  const [item_list, setitem_list] = useState([]);
  console.log("check item list is here",item_list);
  const [search_input, setsearch_input] = useState("");
  const [showDropdown, setShowDropdown] = useState(false);
  const [focusedCell, setFocusedCell] = useState({ rowIndex: null, field: null });
  const [hasMore, setHasMore] = useState(true);
  const [offset, setOffset] = useState(0);
  const itemRefs = useRef([]);
  const dropdownRef = useRef();
  // END NEW STATE VARIABLES

  const handleSaveColumns = (updatedColumns) => {
    setColumns(updatedColumns);
    setShowColumnConfig(false);
  };

  const tableRef = useRef();
  const [rowsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedRows, setSelectedRows] = useState([]);
  const isAllSelected = rows.length > 0 && selectedRows.length === rows.length;
  const indexOfLastRow = currentPage * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;
  const currentRows = rows.slice(indexOfFirstRow, indexOfLastRow);
  const [scanValue, setScanValue] = useState("");
  const [isScanning, setIsScanning] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [scanItemApi] = usePostItemScanApiMutation();

  // NEW FUNCTION TO FETCH ITEMS FOR DROPDOWN
  const getItemdata = async (newOffset = 0, searchText = "") => {
    try {

      // const formData = new FormData();
      // formData.append("name", searchText);
      // formData.append("doctype", "Item");
      // formData.append("start", newOffset);
      // formData.append("page_length", 20);
      
      // const res = await scanItemApi(formData);
      ListAPI(searchText, "Item", setitem_list, {
			query: "erpnext.controllers.queries.item_query",
			filters: {
				is_sales_item: "1",
				customer: formData.customer,
        has_variants:0
			}
		}
		);
      // const products = res?.data?.message || [];
      
      // if (newOffset === 0) {
      //   setitem_list(products);
      // } else {
      //   setitem_list((prev) => [...prev, ...products]);
      // }
      // setHasMore(products.length === 20);
    } catch (err) {
      console.error("Error fetching items:", err);
      setitem_list([]);
    }
  };

  // UPDATE ROW FUNCTION (Modified to handle item selection)
  const updateRow = async (index, field, value) => {
    let updatedRow;
    
    if (field === "item") {

        const formData2 = new FormData();
        formData2.append("name", value.value);
        formData2.append("doctype", "Item");
        const res2 = await scanItemApi(formData2);
         console.log("check response is getting print or not",res2);

      updatedRow = {
        // ...rows[index],
        // item: value,
        // item_code: value.item_code,
        // item_name: value.item_name,
        // custom_pure_gold: value.custom_pure_gold || "0",
        // custom_stone_weight: value.custom_stone_weight || "0",
        // custom_diamond_weight: value.custom_diamond_weight || "0",
        // rate: value.custom_tag_price || rows[index].rate,
            item : {},
            res2: res2?.data?.message,
            quantity: 1,
            rate: res2?.data?.message?.custom_tag_price,
            item_code: res2?.data?.message?.item_code,
            item_name: res2?.data?.message?.item_name,
            custom_pure_gold: "0",
            custom_stone_weight: "0",
            custom_diamond_weight: "0",
            margin_type: '',
            margin_rate_or_amount: '',
            margin_discount_percentage: '',
            margin_discount_amount: '',
      };
    } else {
      updatedRow = { ...rows[index], [field]: value };
    }

    const quantity = parseFloat(updatedRow.quantity) || 0;
    const rate = parseFloat(updatedRow.rate) || 0;
    updatedRow.amount = (quantity * rate).toFixed(2);

    const updatedRows = [...rows];
    updatedRows[index] = updatedRow;
    setRows(updatedRows);
  };

  const handleScanItem = async (e) => {
    if (e.key === "Enter" && scanValue.trim() !== "") {
      const alreadyExists = rows.find((row) => row?.item?.name == scanValue);
      if (alreadyExists) {
        error.seterrorMessage(`Item '${scanValue}' already exists in the table!`);
        error.seterrorType("Error");
        error.setisErrorVisible(true);
        return;
      }

      setIsScanning(true);
      try {
        const formData = new FormData();
        formData.append("name", scanValue);
        formData.append("doctype", "Serial No");
        const res = await scanItemApi(formData);
        const item = res?.data?.message || {};

        const formData2 = new FormData();
        formData2.append("name", item.item_code);
        formData2.append("doctype", "Item");
        const res2 = await scanItemApi(formData2);

        if (item.item_code) {
          const newItem = {
            item,
            res2: res2?.data?.message,
            quantity: 1,
            rate: item?.custom_tag_price,
            item_code: item.item_code,
            item_name: item.item_name,
            custom_pure_gold: item.custom_pure_gold || "0",
            custom_stone_weight: item.custom_stone_weight || "0",
            custom_diamond_weight: item.custom_diamond_weight || "0",
            margin_type: '',
            margin_rate_or_amount: '',
            margin_discount_percentage: '',
            margin_discount_amount: '',
          };

          const blankIndex = rows.findIndex(
            (r) =>
              !r.item_code &&
              !r.item_name &&
              (!r.item || Object.keys(r.item).length === 0)
          );

          let updatedRows = [...rows];

          if (blankIndex !== -1) {
            updatedRows[blankIndex] = newItem;
          } else {
            updatedRows.push(newItem);
          }

          setRows(updatedRows);

          if (rows.length === 0) {
            setCurrentPage(1);
          }

        } else {
          error.seterrorMessage(`Item Not Found`);
          error.seterrorType("Error");
          error.setisErrorVisible(true);
        }
      } catch (err) {
        error.seterrorMessage("Error while scanning item");
        error.seterrorType("Error");
        error.setisErrorVisible(true);
      } finally {
        setIsScanning(false);
        setScanValue("");
      }
    }
  };

  const handleSelectAll = (e) => {
    if (e.target.checked) {
      const pageRowIndices = rows
        .map((_, index) => index)
        .slice(indexOfFirstRow, indexOfLastRow);

      setSelectedRows((prev) => [...new Set([...prev, ...pageRowIndices])]);
    } else {
      const pageRowIndices = rows
        .map((_, index) => index)
        .slice(indexOfFirstRow, indexOfLastRow);

      setSelectedRows((prev) => prev.filter((i) => !pageRowIndices.includes(i)));
    }
  };

  const [popdata, setpopdata] = useState();

  const openEditModal = (row, index, index2) => {
    setShowEditModal(true);
    setpopdata({ row, index, index2, setRows, rows });
  };

  const toggleRowSelection = (index) => {
    setSelectedRows((prev) => prev.includes(index) ? prev.filter((i) => i !== index) : [...prev, index]);
  };

  const handleAddRow = () => {
    const newRows = [...rows, createNewRow()];
    setRows(newRows);
    const lastPage = Math.ceil(newRows.length / rowsPerPage);
    if (currentPage !== lastPage) {
      setCurrentPage(lastPage);
    }
  };

  const handleDeleteSelectedRows = () => {
    const updatedRows = rows.filter((_, idx) => !selectedRows.includes(idx));
    setRows([]);
    setRows(updatedRows);
    setSelectedRows([]);
    const lastPage = Math.ceil(updatedRows.length / rowsPerPage);
    if (currentPage > lastPage) {
      setCurrentPage(lastPage);
    }
  };

  // SCROLL HANDLER FOR DROPDOWN INFINITE SCROLL
  useEffect(() => {
    const dropdown = dropdownRef.current;
    if (!dropdown) return;
    const handleScroll = () => {
      if (dropdown.scrollTop + dropdown.clientHeight >= dropdown.scrollHeight - 10 && hasMore) {
        const newOffset = offset + 20;
        setOffset(newOffset);
        getItemdata(newOffset, search_input);
      }
    };
    dropdown.addEventListener("scroll", handleScroll);
    return () => dropdown.removeEventListener("scroll", handleScroll);
  }, [offset, hasMore, search_input]);

  useEffect(() => {
    const cols = tableRef.current.querySelectorAll("th");
    cols.forEach((col) => {
      const resizer = document.createElement("div");
      resizer.className = "resizer";
      col.appendChild(resizer);

      let x = 0;
      let w = 0;

      const onMouseDown = (e) => {
        x = e.clientX;
        w = col.offsetWidth;

        document.addEventListener("mousemove", onMouseMove);
        document.addEventListener("mouseup", onMouseUp);
      };

      const onMouseMove = (e) => {
        const dx = e.clientX - x;
        col.style.width = `${w + dx}px`;
      };

      const onMouseUp = () => {
        document.removeEventListener("mousemove", onMouseMove);
        document.removeEventListener("mouseup", onMouseUp);
      };

      resizer.addEventListener("mousedown", onMouseDown);
    });
  }, []);

  return (
    <div className="px-2" style={{ border: '1px solid #DBDBDB', borderRadius: '4px' }}>
      <div className="py-2  d-flex justify-content-between">
        <p className='m-0' style={{ fontSize: '16px', fontWeight: '600' }}>Items</p>
        <div className="buttondiv d-flex " style={{ gap: '5px', width: '200px' }}>
          <div style={{ width: '100%' }}>
            <input
              type="text"
              className="form-control"
              style={{ fontSize: "12px", height: "100%", padding: "5px 8px" }}
              placeholder="Scan or Enter Item Code"
              value={scanValue}
              onChange={(e) => setScanValue(e.target.value)}
              onKeyDown={handleScanItem}
              disabled={isScanning}
            />
          </div>
        </div>
      </div>
      <table className="table table-bordered mb-1" ref={tableRef}>
        <thead className="tableHead1">
          <tr>
            {visibleColumns.map((col, index) => (
              <th
                key={col.key}
                style={{
                  width: col.width,
                  textAlign: "center",
                  position: "relative"
                }}
              >
                {col.key === "setting" ? (
                  <div onClick={() => setShowColumnConfig(true)} style={{ cursor: "pointer" }}>
                    <GetIcon iconName="IoSettingsOutline" size={14} />
                  </div>
                ) : (col.key === "action" ? <input
                      type="checkbox"
                      className="form-check-input"
                      style={{ backgroundColor: isAllSelected ? "#270b79" : "", borderColor: isAllSelected ? "#270b79" : "", fontSize: '15px' }}
                      checked={isAllSelected}
                      onChange={handleSelectAll}
                    />
                   : col.name
                )}
              </th>
            ))}
          </tr>
        </thead>

        <tbody>
          {currentRows.map((row, index) => {
            const globalIndex = indexOfFirstRow + index;
            const calculatedAmount = (parseFloat(row.quantity || 0) * parseFloat(row.rate || 0));

            return (
              <tr key={globalIndex} style={{ height: '30px' }}>
                <td className={`p-0 ${!visibleColumns.find(col => col.key === "action") && 'd-none'}`} style={{ cursor: 'pointer' }}>
                  <p className="m-0" style={{ position: 'relative', top: "5px" }}>
                    {selectedRows.includes(globalIndex) ? (
                      <span onClick={() => toggleRowSelection(globalIndex)}>
                        <input
                          type="checkbox"
                          className="form-check-input"
                          style={{ backgroundColor: "#270b79", fontSize: '15px', borderColor: '#270b79' }}
                          checked
                        />
                      </span>
                    ) : (
                      <span onClick={() => toggleRowSelection(globalIndex)}>
                        <input type="checkbox" className="form-check-input" style={{ fontSize: '15px' }} />
                      </span>
                    )}
                  </p>
                </td>
                <td className={`p-0 ${!visibleColumns.find(col => col.key === "slno") && 'd-none'}`} style={{
                  textAlign: "center",
                  fontSize: '0.8rem',
                  lineHeight: '29px'
                }}>
                  {globalIndex + 1}
                </td>

                {/* Design Code with Dropdown Search - ADDED THIS FEATURE */}
                {po_status == "" ? (
                  <td className={`p-0 d-flex justify-content-center ${!visibleColumns.find(col => col.key === "design_code") && 'd-none'}`} style={{
                    position: "relative",
                    border: focusedCell.rowIndex === globalIndex && focusedCell.field === 'item_code' ? '0.3px solid #270b79' : ''
                  }}>
                    <input
                      type="text"
                      className="p-0 form-control tableinput noborder"
                      style={{ fontSize: '0.8rem', height: '28.4px', textAlign: 'center' }}
                      onFocus={() => {
                        getItemdata();
                        setTimeout(() => {
                          setShowDropdown(globalIndex);
                          setFocusedCell({ rowIndex: globalIndex, field: 'item_code' });
                        }, 302);
                      }}
                      onBlur={() => {
                        setTimeout(() => {
                          setShowDropdown(false);
                          setFocusedCell({ rowIndex: null, field: null });
                        }, 300)
                      }}
                      onChange={(e) => {
                        setsearch_input(e.target.value);
                        setOffset(0);
                        getItemdata(0, e.target.value);
                        // Only update if you want to allow manual typing
                        // updateRow(globalIndex, "item_code", e.target.value);
                      }}
                      onKeyDown={(e) => {
                        if (showDropdown === globalIndex && item_list.length > 0) {
                          if (e.key === "Enter") {
                            e.preventDefault();
                            const selectedItem = item_list[0];
                            updateRow(globalIndex, "item", selectedItem);
                            setsearch_input("");
                          }
                        }
                      }}
                      value={
                        search_input !== "" && focusedCell.rowIndex === globalIndex
                          ? search_input
                          : focusedCell.rowIndex === globalIndex && search_input === "" && row.item_code === ""
                            ? ""
                            : (row.item_code || "")
                      }
                    />

                    <div
                      ref={dropdownRef}
                      style={{
                        position: "absolute",
                        top: "100%",
                        left: 0,
                        right: 0,
                        maxHeight: showDropdown === globalIndex ? "200px" : "0",
                        display: showDropdown === globalIndex ? '' : 'none',
                        overflowY: "auto",
                        background: "white",
                        border: showDropdown === globalIndex ? "1px solid #ccc" : "",
                        zIndex: 10,
                      }}
                    >
                      {item_list.map((item, idx) => (
                        <div
                          key={idx}
                          ref={el => (itemRefs.current[idx] = el)}
                          onClick={() => {
                            console.log("Selected item:", item);
                            updateRow(globalIndex, "item", item);
                            setsearch_input("");
                            setShowDropdown(false);
                          }}
                          style={{
                            padding: "8px",
                            cursor: "pointer",
                            borderBottom: "1px solid #eee",
                            backgroundColor: "white",
                          }}
                        >
                          <p className="m-0">
                            {item.value}
                          </p>
                          <div style={{ fontSize: '10px' }}>
                            {item?.description}
                          </div>
                        </div>
                      ))}
                      {!hasMore && item_list.length === 0 && (
                        <div style={{ padding: "8px", color: "#888" }}>No results</div>
                      )}
                    </div>
                  </td>
                ) : (
                  <td className={`p-0 d-flex justify-content-center ${!visibleColumns.find(col => col.key === "design_code") && 'd-none'}`} >
                    <input
                      type="text"
                      className="p-0 form-control tableinput noborder"
                      style={{ fontSize: '0.8rem', height: '28.4px', textAlign: 'center' }}
                      readOnly
                      value={row.item_code}
                    />
                  </td>
                )}

                {/* Item Name */}
                <td className={`p-0 ${!visibleColumns.find(col => col.key === "item_name") && 'd-none'}`}>
                  <input
                    type="text"
                    className=" p-0 form-control tableinput noborder"
                    style={{ fontSize: '0.8rem', textAlign: 'center', lineHeight: '29px' }}
                    readOnly
                    value={row?.item_name || ""}
                  />
                </td>

                <td className={`p-0 ${!visibleColumns.find(col => col.key === "diamond_weight") && 'd-none'}`}>
                  <input
                    type="text"
                    className=" p-0 form-control tableinput noborder"
                    style={{ fontSize: '0.8rem', textAlign: 'center', lineHeight: '29px' }}
                    readOnly
                    value={row?.custom_diamond_weight || ""}
                  />
                </td>

                <td className={`p-0 ${!visibleColumns.find(col => col.key === "stone_weight") && 'd-none'}`}>
                  <input
                    type="text"
                    className=" p-0 form-control tableinput noborder"
                    style={{ fontSize: '0.8rem', textAlign: 'center', lineHeight: '29px' }}
                    readOnly
                    value={row?.custom_stone_weight || ""}
                  />
                </td>
                <td className={`p-0 ${!visibleColumns.find(col => col.key === "pure_gold") && 'd-none'}`}>
                  <input
                    type="text"
                    className=" p-0 form-control tableinput noborder"
                    style={{ fontSize: '0.8rem', textAlign: 'center', lineHeight: '29px' }}
                    readOnly
                    value={row?.custom_pure_gold || ""}
                  />
                </td>
                <td className={`p-0 ${!visibleColumns.find(col => col.key === "rate") && 'd-none'}`}>
                  <input
                    type={selectedRow != index ? "text" : "number"}
                    className=" p-0 form-control tableinput noborder"
                    style={{ fontSize: '0.8rem', textAlign: 'center', lineHeight: '29px' }}
                    value={selectedRow != index ? formatIndianPriceWithComa(parseFloat(row.rate)) : row.rate || ""}
                    onFocus={() => {
                      setTimeout(() => {
                        setselectedRow(index);
                      }, 290);
                    }}
                    onBlur={() => {
                      setTimeout(() => {
                        setselectedRow(null);
                      }, 90);
                    }}
                    onChange={(e) => {
                      const newRate = parseFloat(e.target.value) || 0;
                      const tagPrice = parseFloat(row?.item?.custom_tag_price) || 0;

                      const discountAmount = tagPrice - newRate;
                      const discountPercentage = tagPrice ? ((discountAmount / tagPrice) * 100).toFixed(2) : 0;

                      const updatedRows = rows.map((row, idx) =>
                        idx === index ? {
                          ...row,
                          rate: newRate,
                          margin_discount_percentage: discountPercentage,
                          margin_discount_amount: discountAmount,
                          margin_rate_or_amount: '',
                        } : row
                      );
                      setRows(updatedRows);
                    }}
                  />
                </td>

                <td className={`p-0 ${!visibleColumns.find(col => col.key === "amount") && 'd-none'}`}>
                  <input
                    type="text"
                    className=" p-0 form-control tableinput noborder"
                    style={{ fontSize: '0.8rem', textAlign: 'center', lineHeight: '29px' }}
                    readOnly
                    value={formatIndianPriceWithComa(calculatedAmount)}
                  />
                </td>

                <td className="p-0">
                  <span
                    onClick={() => openEditModal(row, globalIndex, index)}
                    style={{ cursor: 'pointer' }}
                  >
                    <GetIcon iconName="MdOutlineEdit" size={15} />
                  </span>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>

      {/* Rest of your component remains the same */}
      <div className="d-flex pb-2 justify-content-between align-items-center">
        <div className="d-flex" style={{ gap: '4px' }}>
          {selectedRows.length > 0 && po_status == '' && (
            <Button
              onClick={handleDeleteSelectedRows}
              className="customdeletebtn "
              iconName="MdDeleteOutline"
              iconSize={12}
            >
              Delete
            </Button>
          )}
          {selectedRows.length == 0 && po_status == '' && (
            <Button
              onClick={handleAddRow}
              className="Addrowdesign"
              iconName="FiPlus"
              iconSize={12}
              iconWrapperStyle={{ backgroundColor: '#F6D593', padding: '1px', display: 'flex' }}
            >
              Add Row
            </Button>
          )}
          <Button
            className="createbtn d-flex"
            style={{ gap: '2px', height: '28px' }}
            iconName="MdOutlineFileDownload"
            iconSize={12}
            onClick={() => {
              handleDownloadCSV([
                "S.No",
                "Item Design (Items)",
                "Item Name (Items)",
                "Category",
                "Sub Category",
                "Diamond Weight",
                "Stone Weight",
                "Pure Gold",
                "Quantity (Items)",
                "Rate (Items)",
                "UOM (Items)",
                "Amount"
              ], rows,
                "purchase_order")
            }}
          >
            Download
          </Button>

          <Button
            className="createbtnNew d-flex"
            style={{ gap: '2px', height: '28px' }}
            iconName="MdOutlineFileDownload"
            iconSize={12}
          >
            Upload
          </Button>
        </div>

        <div className={`${rows.length < 11 ? "d-none" : "d-flex"} align-items-center centerpagination`} style={{ gap: '5px' }}>
          <Pagination
            setCurrentPage={setCurrentPage}
            currentPage={currentPage}
            pageSize={rowsPerPage}
            totalrecords={rows.length}
          />
        </div>

        <div className={`${rows.length < 11 ? "d-none" : "d-flex"}`}>
          <span className="px-2" style={{ fontSize: '12px', color: '#823455' }}>
            Showing {indexOfFirstRow + 1} to {Math.min(indexOfLastRow, rows.length)} of {rows.length} entries
          </span>
        </div>
      </div>

      <ConfigureColumns
        show={showColumnConfig}
        onClose={() => setShowColumnConfig(false)}
        onSave={handleSaveColumns}
        initialFields={columns}
      />

      {showEditModal &&
        <EditItemModal
          show={showEditModal}
          onClose={() => setShowEditModal(false)}
          itemDataReal={popdata}
          updateRow={updateRow}
        />
      }
    </div>
  );
};

export default ItemTable;